<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span class="">Filter by Years</span>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div class="row">
        <div class="col-xs-6">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
        </div>
        <div class="col-xs-6 text-right">
          <a role="button" class="text-info"
             style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
        </div>
      </div>
    </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(year, key) in years" v-if="year"  :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-year-' + year.name" type="checkbox" v-on:change="yearSelected(year)"
                 v-bind:checked="checked(year)" :disabled="year.nb === 0">
          <label :for="uniqId + 'checkbox-year-' + year.name">
            <template v-if="!year.name">Undefined</template>
            <template v-else>{{year.name}}</template> ({{year.nb}})
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['years', 'yearsSelected'],
  name: 'DateIncorporated',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (year) {
      if (this.yearsSelected.length !== 0) {
        let tmpYearSelected = this.yearsSelected.find((yearSelected) => {
          return yearSelected.name === year.name
        })
        if (typeof tmpYearSelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    yearSelected: function (year) {
      let index = this.yearsSelected.map((e) => {
        return e.name
      }).indexOf(year.name)

      if (index === -1) {
        this.yearsSelected.push(year)
      } else {
        this.yearsSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.yearsSelected.splice(0, this.yearsSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.years.forEach((year) => {
        this.yearsSelected.push(year)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/DateIncorporated.vue